<template>
	<div class="section_characterInfo">
		<img :src="props.item.file_path" class="characterInfo_img" alt="대가 일러스트" loading="lazy" />
		<div class="characterInfo_content">
			<p class="content_name">{{ props.item.master_name }}</p>
			<p class="content_motto">{{ props.item.master_motto }}</p>
		</div>
		<!-- <button v-if="props.subYn === 0" class="characterInfo_subBtn" @click="onClickPayment">구독하기</button>
		<p v-if="props.subYn === 1" class="characterInfo_subTxt">구독중</p> -->
	</div>
</template>
<script setup lang="ts">
// core

// api
import { Master } from '@/api/master';
// constant
// store

// const tokenStore = useTokenStore();
// const loginPopupStore = useLoginPopupStore();
// const router = useRouter();

const props = defineProps<{
	item: Master;
	subYn: number;
}>();

// 구독하기 버튼 클릭 시 실행 함수
// const onClickPayment = () => {
// 	if (!tokenStore.isLogin) {
// 		loginPopupStore.openPopup({
// 			icon: 'alert',
// 			content: LOGIN_REQUIRED_PAGE,
// 			confirm: () =>
// 				router.push({
// 					name: 'auth/login',
// 					query: {
// 						isPayment: 'true',
// 					},
// 				}),
// 			confirmText: CONFIRM_LOGIN,
// 			cancelText: CANCEL,
// 		});
// 	} else {
// 		router.push('/payment');
// 	}
// };
</script>

<style lang="scss" scoped>
.section_characterInfo {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.8rem;
	text-align: center;
	background-color: var(--color-bg-mid);
	padding: 2.4rem 2rem;
	border-radius: 0.8rem;
	border: 1px solid var(--color-base-mid);
	.characterInfo_img {
		height: 10rem;
		object-fit: contain;
	}
	.characterInfo_content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.4rem;
		.content_name {
			font-size: var(--font-s-x-large);
			font-weight: var(--font-w-bold);
			line-height: normal;
		}
		.content_motto {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-light);
			color: var(--color-base-light);
			line-height: 2.3rem;
		}
	}
	.characterInfo_subBtn {
		width: 24rem;
		padding: 1.35rem 1.6rem;
		font-size: var(--font-s-regular);
		font-weight: var(--font-w-medium);
		line-height: 2.1rem;
		background-color: var(--color-primary);
		border-radius: 0.6rem;
	}
	.characterInfo_subTxt {
		font-size: var(--font-s-regular);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.1rem;
		color: var(--color-secondary-Blue);
	}
}
</style>
